import { ReactElement, useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';

import { useHirePlanForm } from '../../../../../contexts/HirePlanFormProvider';
import { paymentOptions } from '../data/paymentOptions';
import { PaymentOptionDescription } from './PaymentOptionDescription';
import { PaymentSelectorItem } from './PaymentSelectorItem';
import { PaymentCreditCardForm } from './PaymentOptionsForms/CreditCardForm';
import { PaymentBilletForm } from './PaymentOptionsForms/BilletForm';
import { PaymentDebitForm } from './PaymentOptionsForms/DebitForm';
import { useRouteLoaderData } from 'react-router-dom';
import { usePaymentStore } from '../../../../../stores/usePaymentStore';
import { useBoostedPlanDataStore } from '../../../../../stores/useBoostedPlanDataStore';
import { useNordesteStore } from '../../../../../stores/useNordesteStore';
import {
  IndividualWithShortageNorthEastIds,
  IndividualWithShortageNorthEastTokens,
  IndividualWithShortageTokens,
} from '../../../../../utils/Enums/Tokens';
import { fetchPlan } from '../../../../../requests/requests';

interface PaymentSelector {
  payment: number;
}

export function PaymentSelector(): ReactElement {
  const initialPlanData = useBoostedPlanDataStore(state => state.data);
  const setPaymentId = usePaymentStore(state => state.setId);
  const paymentId = usePaymentStore(state => state.id);
  const setBoostPlanData = useBoostedPlanDataStore(
    state => state.setBoostPlanData,
  );
  const NE = useNordesteStore(x => x.data);

  async function handlepaymentNorthEastChange(type: number) {
    const vendedorId = initialPlanData.vendedorId;
    console.log('Token: ', initialPlanData);
    switch (initialPlanData.token) {
      case IndividualWithShortageNorthEastTokens.CLINICO:
      case IndividualWithShortageNorthEastTokens.CLINICO_AN:
      case IndividualWithShortageTokens.CLINICO:
      case IndividualWithShortageTokens.CLINICONA: {
        const response = await fetchPlan(
          type == 1
            ? IndividualWithShortageNorthEastIds.CLINICO_AN
            : IndividualWithShortageNorthEastIds.CLINICO,
          vendedorId,
        );
        setBoostPlanData(response);
        break;
      }
      case IndividualWithShortageNorthEastTokens.ORTO:
      case IndividualWithShortageNorthEastTokens.ORTO_AN:
      case IndividualWithShortageTokens.ORTO: {
        const response = await fetchPlan(
          type == 1
            ? IndividualWithShortageNorthEastIds.ORTO_AN
            : IndividualWithShortageNorthEastIds.ORTO,
          vendedorId,
        );
        setBoostPlanData(response);
        break;
      }
      case IndividualWithShortageNorthEastTokens.DOC:
      case IndividualWithShortageNorthEastTokens.DOC_AN:
      case IndividualWithShortageTokens.DOC: {
        const response = await fetchPlan(
          type == 1
            ? IndividualWithShortageNorthEastIds.DOC_AN
            : IndividualWithShortageNorthEastIds.DOC,
          vendedorId,
        );
        setBoostPlanData(response);
        break;
      }
      case IndividualWithShortageNorthEastTokens.PROTESE:
      case IndividualWithShortageNorthEastTokens.PROTESE_AN:
      case IndividualWithShortageTokens.PROTESE: {
        const response = await fetchPlan(
          type == 1
            ? IndividualWithShortageNorthEastIds.PROTESE_AN
            : IndividualWithShortageNorthEastIds.PROTESE,
          vendedorId,
        );
        setBoostPlanData(response);
        break;
      }
      case IndividualWithShortageNorthEastTokens.KIDS:
      case IndividualWithShortageNorthEastTokens.KIDS_AN:
      case IndividualWithShortageTokens.KIDS: {
        const response = await fetchPlan(
          type == 1
            ? IndividualWithShortageNorthEastIds.KIDS_AN
            : IndividualWithShortageNorthEastIds.KIDS,
          vendedorId,
        );
        setBoostPlanData(response);
        break;
      }
    }
  }

  const [grupoPagamento, setGrupoPagamento] = useState(Array);

  useEffect(() => {
    const grupos: number[] = [];
    initialPlanData.formasPagamento.map(paymentOption => {
      grupos.push(paymentOption.meioPagamentoIndividual.cd_gmeiopagto);
    });
    setGrupoPagamento(grupos);
    if (NE) {
      if (!grupos.includes(1)) {
        grupos.push(1);
      }
      if (!grupos.includes(2)) {
        grupos.push(2);
      }
      if (
        initialPlanData.produtoComercial.id_prodcomerc == 1018 &&
        !grupos.includes(3)
      ) {
        grupos.push(3);
      }
    }
  }, [initialPlanData]);
  const setTipoPagamento = async (tipo: number) => {
    if (NE) {
      await handlepaymentNorthEastChange(tipo);
    }
    setPaymentId(tipo);
  };

  return (
    <>
      <div className="flex max-[1000px]:flex-col max-[1000px]:items-center w-full min-[748px]:mt-20">
        <nav
          className="min-[748px] w-full"
          aria-label="Opções de métodos de pagamento"
        >
          <ul className="flex flex-row gap-[14px] ">
            {paymentOptions.map(option => {
              for (const grupo of grupoPagamento) {
                if (grupo == option.id) {
                  return (
                    <PaymentSelectorItem
                      key={option.id}
                      label={option.label}
                      active={option.id === paymentId}
                      onClick={() => setTipoPagamento(option.id)}
                      Icon={option.Icon}
                      title={option.label}
                    />
                  );
                }
              }
            })}
          </ul>
        </nav>
      </div>
      {paymentId == 1 ? (
        <>
          <PaymentOptionDescription paymentId={paymentId} />
          <PaymentCreditCardForm />
        </>
      ) : paymentId == 3 ? (
        <>
          <PaymentOptionDescription paymentId={paymentId} />
          <PaymentBilletForm />
        </>
      ) : (
        paymentId == 2 && (
          <>
            <PaymentOptionDescription paymentId={paymentId} />
            <PaymentDebitForm />
          </>
        )
      )}
    </>
  );
}
